import { auth, setCustomer } from "@/redux/ducks/customer";
import { ReducersTypes } from "@/redux/reducers/Models";
import { validateCPF } from "@/utils/functions";
import { InputMask } from "@react-input/mask";
import { useState, KeyboardEvent, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Modal from "../Modal";
import Loading from "../Loading";

const LoginModal = ({
  toggleModalLogin,
}: {
  toggleModalLogin: () => void;
}) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const customer = useSelector((state: ReducersTypes) => state.customerReducer);

  const [isLoading, setIsLoading] = useState(false);
  const [isVisiblePassword, setIsVisiblePassword] = useState(false);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [password, setPassword] = useState("");
  const refPassword = useRef<HTMLInputElement>(null);

  const toggleIsVisiblePassword = () => setIsVisiblePassword(isVisiblePassword => !isVisiblePassword);
  const toggleModal = () => setIsVisibleModal(isVisibleModal => !isVisibleModal);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    dispatch(setCustomer({ [name]: value }));
  }

  const onInput = () => {
    setPassword(refPassword.current?.value ?? "");
  };

  const getIsValidAuth = () => {
    return validateCPF(customer?.username ?? "") && !!password;
  }

  const goToCreateAccount = () => {
    navigate("/register");
  }

  const handleKeyDown: (event: KeyboardEvent<HTMLInputElement>) => void = (event) => {
    if (event.key === 'Enter') {
      authLogin();
    }
  };

  const handleAuth = (success: boolean, _?: string) => {
    setIsLoading(false);

    if (!success) {
      toggleModal();
    }

  }

  const authLogin: (e?: React.FormEvent<HTMLFormElement>) => void = (e) => {
    e?.preventDefault();

    if (!getIsValidAuth() || isLoading) return;

    setIsLoading(true);

    dispatch(
      auth({
        username: customer?.username!,
        password,
        callback: handleAuth,
      })
    );
  }

  return (
    <div className="fixed flex flex-1 top-0 left-0 right-0 bottom-0 z-20 w-full bg-black/30 justify-center items-start text-black h-full min-h-screen">
      <button
        type="button"
        className="absolute top-0 right-0 left-0 bottom-0"
        onClick={toggleModalLogin}
      />
      <div className="relative w-full max-w-[calc(480px)] max-h-full mt-[calc(100px)]">
        <div className="relative bg-white rounded-2xl shadow p-5">
          <form className="w-full flex flex-col items-center pb-3" onSubmit={authLogin}>
            <InputMask
              value={customer?.username ?? ''}
              name="username"
              placeholder="Seu CPF"
              className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              mask="___.___.___-__"
              replacement={{ _: /\d/ }}
              onChange={(e) => onChange(e)}
              required
              type="text"
            />
            <div className="flex flex-col w-full mt-3 relative">
              <input
                required
                onInput={onInput}
                type={isVisiblePassword ? "text" : "password"}
                name="password"
                onKeyDown={handleKeyDown}
                placeholder="Sua senha"
                ref={refPassword}
                className="text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              <button type="button" onClick={toggleIsVisiblePassword} className="absolute right-2 top-5">
                <img
                  src={isVisiblePassword ? "/eye-hidden.png" : "/icon-eye.png"}
                  width={24}
                  height={24}
                  alt="Visualizar senha"
                />
              </button>
            </div>
            <Link to="/forgot" className='text-gray-400 underline text-sm flex self-end mt-3'>
              Esqueci a senha
            </Link>
            <button
              type="submit"
              disabled={!getIsValidAuth()}
              className={`mt-4 mb-3 ${!getIsValidAuth() ? "bg-gray-400 text-white" : "bg-black text-principal"} border p-2 rounded-lg h-[calc(60px)] w-full`}>
              Acessar conta
            </button>
            <p className="text-sm mt-7 text-center text-gray-600">Você ainda não tem uma conta?</p>
            <button type="button" onClick={goToCreateAccount} className="mt-4 mb-1 bg-white border border-black font-bold p-2 rounded-lg h-[calc(60px)] text-black w-full">Criar uma conta</button>
          </form>
        </div>
      </div>
      {isVisibleModal && <Modal
        title="Atenção!"
        message="CPF ou senha inválidos."
        actionMessage="Fechar"
        action={toggleModal}
        hasCloseButton={false}
      />}
      {isLoading && <Loading />}
    </div>
  );
}

export default LoginModal;